import { PictureUpload } from "@/components/common/picture-upload/picture-upload";
import { cn } from "@/lib/utils";
import { getMaxPatronHeight } from "@/service/patron/patron-image";

export const MultiplePatrons = ({
  patrons,
  bottom = false,
  left = false,
}: {
  patrons: PatronVM[];
  bottom?: boolean;
  left?: boolean;
}) => {
  if (patrons.length === 0) {
    return null;
  }

  return (
    <div
      className={cn(
        "flex items-center justify-center gap-4 md:justify-end",
        bottom && "flex-col justify-center",
        left && "justify-start",
      )}
    >
      <span className="text-sm font-medium">
        {patrons.length === 1 ? "Patron:" : "Patroni:"}
      </span>
      <div className="flex items-center gap-4">
        {patrons.map(
          ({ image, link, id }) =>
            image && (
              <div key={id} className="inline-block">
                {link ? (
                  <a
                    href={link}
                    target={"_blank"}
                    rel="noreferrer nofollow noopener"
                  >
                    <PictureUpload
                      image={image}
                      loaded={true}
                      maxHeight={getMaxPatronHeight(image, 0.6)}
                      className={"w-auto"}
                    />
                  </a>
                ) : (
                  <PictureUpload
                    image={image}
                    loaded={true}
                    maxHeight={getMaxPatronHeight(image, 0.6)}
                    className={"w-auto"}
                  />
                )}
              </div>
            ),
        )}
      </div>
    </div>
  );
};
